module.exports = __webpack_public_path__ + "img/23.2b5caaee.png";